import { env } from 'next-runtime-env'

export const getSgToken = async (appId: string, authKey: string) => {
  try {
    const SG_TOKEN_API = `${env(
      'NEXT_PUBLIC_ACCOUNT_SERVER',
    )}/SS/api/oauth/v1/vendor/token/access-token`

    const response = await fetch(`${SG_TOKEN_API}?clientId=${appId}&enableRefreshToken=true`, {
      headers: {
        authKey: authKey,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    console.error('Failed to get SG token:', error)
    throw error
  }
}
